import { render, staticRenderFns } from "./RecipeCard.vue?vue&type=template&id=461588c8&scoped=true"
import script from "./RecipeCard.vue?vue&type=script&lang=js"
export * from "./RecipeCard.vue?vue&type=script&lang=js"
import style0 from "./RecipeCard.vue?vue&type=style&index=0&id=461588c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461588c8",
  null
  
)

export default component.exports